// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"56f50944","188":"84f3d75c","234":"68104885","247":"0e25dc54","471":"fe742512","488":"717787d7","512":"c9664fe5","546":"3695ad65","696":"88605b60","805":"00b2838e","833":"b469de63"}[chunkId] + ".chunk.js";
};